import { render, staticRenderFns } from "./editPhoto.vue?vue&type=template&id=42c44538&"
import script from "./editPhoto.vue?vue&type=script&lang=js&"
export * from "./editPhoto.vue?vue&type=script&lang=js&"
import style0 from "./editPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports